<template>
  <el-form @submit.native.prevent class="creative-form" :model="group" :rules="creativeFormRules" label-width="180px">
    <Moduler name="a" title="创意形式">
      <template v-if="isSearchAd">
        <el-form-item label="创意组名称" prop="groupName">
          <el-input v-model="group.groupName" placeholder="请输入文案（1-20个字）"></el-input>
        </el-form-item>
        <el-form-item label="创意名称" prop="dynamic_creative_name">
          <el-input v-model="group.dynamic_creative_name" placeholder="请输入创意名称（1-100个字）"></el-input>
        </el-form-item>
      </template>

      <CreativeTemplateForm v-else :value="group" @input="(e) => $emit('update-group', e)" :planForm="planForm"></CreativeTemplateForm>
    </Moduler>

    <Moduler name="a" title="创意内容">
      <template v-if="!isWxGamePlayable">
        <el-form-item label="创意素材" prop="selectedAssets">
          <slot name="selectedmaterials"></slot>
        </el-form-item>

        <el-form-item label="创意文案" prop="description">
          <div style="margin-bottom: 10px">
            <el-button v-if="currDescriptionLen < 3" type="primary" @click="addCreativeDescription"> 添加文案组 </el-button>
            <span>（{{ currDescriptionLen }}/3）</span>
          </div>
          <div class="description-list" v-for="(text, index) in group.description" :key="index">
            <el-input v-model="text.content" placeholder="请输入文案（1-30个字）"></el-input>
            <em
              v-if="group.description.length > 1"
              class="el-icon-remove"
              style="line-height: 32px"
              @click="onCreativeDescriptionRemove(index)"
            ></em>
          </div>
        </el-form-item>
      </template>

      <!-- 搜索广告描述 -->
      <template v-if="group.description_component_options">
        <el-form-item label="描述" prop="description_component_options">
          <DescriptionList v-model="group.description_component_options"></DescriptionList>
        </el-form-item>
      </template>

      <!-- 批量失败修改、批量复制、单条修改时显示 -->
      <el-form-item v-if="showBrandForm" label="品牌形象跳转" prop="components.brand">
        <el-radio-group v-model="group.components.brand.brandType">
          <!-- 包含朋友圈才显示简介页 -->
          <el-radio-button ghost :label="BRAND_ENUM.PROFILE" :disabled="isWxGamePlayable" v-if="hasMoment"> 品牌简介页 </el-radio-button>
          <el-radio-button ghost :label="BRAND_ENUM.BRAND">品牌跳转</el-radio-button>
          <el-radio-button ghost :label="BRAND_ENUM.CHANNEL" :disabled="isWxGamePlayable">视频号</el-radio-button>
          <el-radio-button ghost :label="BRAND_ENUM.OFFICIAL_ACCOUNT" :disabled="isWxGamePlayable">公众号</el-radio-button>
        </el-radio-group>

        <div style="margin-top: 10px">
          <el-select
            v-if="group.components.brand.brandType === BRAND_ENUM.CHANNEL"
            v-model="group.components.wechat_channels.channelInfo.promoted_object_id"
            placeholder="请选择视频号"
          >
            <el-option
              v-for="item in promotedObjectChannelList"
              :key="item.promoted_object_id"
              :label="item.promoted_object_name"
              :value="item.promoted_object_id"
            >
            </el-option>
          </el-select>

          <el-select
            v-else-if="group.components.brand.brandType === BRAND_ENUM.OFFICIAL_ACCOUNT"
            v-model="group.components.brand.officialAccountInfo.promoted_object_id"
            placeholder="请选择公众号"
          >
            <el-option
              v-for="item in officialAccountList"
              :key="item.promoted_object_id"
              :label="item.promoted_object_name"
              :value="item.promoted_object_id"
            >
            </el-option>
          </el-select>

          <!-- 品牌形象 -->

          <template v-else-if="group.components.brand.brandType === BRAND_ENUM.BRAND">
            <el-select v-model="group.components.brand.brandInfo" value-key="image_id" filterable placeholder="请选择品牌形象">
              <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.name" :value="brand">
                <span class="profile-opts">
                  <img :src="brand.image_url" />
                  <span>{{ brand.name }}</span>
                </span>
              </el-option>
            </el-select>

            <slot name="brandbtns"> </slot>
          </template>
          <!-- 品牌简介页 -->
          <template v-else>
            <el-select v-model="group.components.brand.profileInfo" value-key="profile_id" filterable placeholder="请选择品牌简介页">
              <el-option v-for="profile in profileList" :key="profile.profile_id" :label="profile.profile_name" :value="profile">
                <span class="profile-opts">
                  <img :src="profile.head_image_url" />
                  <span>{{ profile.profile_name }}</span>
                </span>
              </el-option>
            </el-select>
            <slot name="profilebtns"></slot>
          </template>
        </div>
      </el-form-item>

      <slot name="page"></slot>
    </Moduler>

    <!-- 搜索广告不显示营销组件 -->
    <Moduler name="a" title="营销组件" v-if="!isSearchAd">
      <slot></slot>
    </Moduler>
  </el-form>
</template>

<script>
import { toRef } from 'vue'
import Moduler from '@/components/moduler'
// 创意形式
import CreativeTemplateForm from '@/views/create/gdt/template/components/creative/components/creative-form/creative-form-template.vue'
import DescriptionList from '@/views/create/gdt/template/components/creative/description-list.vue'

import { creativeFormV3Rules } from '@/views/create/gdt/model/creative-rules.js'
import {
  DYNAMIC_CREATIVE_TYPE,
  BRAND_ENUM,
  MINIGAME_CONVERSION_TARGET_LIST,
  APP_CONVERSION_TARGET_LIST
} from '@/views/create/gdt/model/creative-const.js'
import { SITE_ENUM } from '@/views/create/gdt/model/siteset/siteset-const.js'
import { AD_MARKETING_SCENE, PLATFORM } from '@/views/create/gdt/model/project-const.js'
import { useGdtCreativeComputes } from '@/views/create/gdt/template/hooks/utils/creative.js'

export default {
  props: {
    group: Object,
    adAcoountId: Number,
    profileList: Array,
    brandList: Array,
    barrageList: Array,
    promotedObjectChannelList: Array,
    officialAccountList: Array
  },
  inject: ['creativeInstance'],
  components: {
    Moduler,
    DescriptionList,
    CreativeTemplateForm
  },
  setup(props) {
    const { isWxGamePlayable } = useGdtCreativeComputes(toRef(props, 'group'))
    return { isWxGamePlayable }
  },
  data() {
    return {
      DYNAMIC_CREATIVE_TYPE,
      BRAND_ENUM,
      MINIGAME_CONVERSION_TARGET_LIST,
      APP_CONVERSION_TARGET_LIST,

      creativeFormRules: creativeFormV3Rules.call(this),
      emojiRegExp: new RegExp(/\[(.*?)\]/, 'g')
    }
  },
  computed: {
    /**
     * @description: 是否启用首评回复
     * @return {*}
     */
    isFirstCommentComponentEnable() {
      return this.group.components.social_skill?.social_skill_first_comment?.trim()?.length > 0
    },
    planForm() {
      return this.creativeInstance.planForm
    },
    hasMoment() {
      return this.planForm.siteSet?.includes(SITE_ENUM.MOMENTS) || false
    },
    currDescriptionLen() {
      return this.group.description.length
    },
    isSearchAd() {
      return this.planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
    },
    showBrandForm() {
      const { isModify, isDuplicate, isUpdateCreative } = this.creativeInstance?.pageStates || {}
      return isModify || isDuplicate || isUpdateCreative
    }
  },
  watch: {
    isFirstCommentComponentEnable(val) {
      this.onFirstCommentEnableChange(val)
    },
    isWxGamePlayable(val) {
      if (val) {
        const components = this.group.components
        components.brand.brandType = BRAND_ENUM.BRAND
        this.group.components = components
      }
    }
  },
  methods: {
    onFirstCommentEnableChange(v) {
      if (v) {
        const components = this.group.components
        components.brand.brandType = BRAND_ENUM.CHANNEL
        this.group.components = components
      }
    },
    /**
     * @description: 新增创意文案，最多3个
     */
    addCreativeDescription() {
      if (this.currDescriptionLen >= 3) return
      this.group.description.push({ content: '' })
    },
    onCreativeDescriptionRemove(idx) {
      this.group.description.splice(idx, 1)
    },

    /**
     * @description: 清空已选弹幕
     * @return {*}
     */
    onBarrageClear() {
      this.group.components.barrage = []
    }
  }
}
</script>

<style lang="scss">
// 品牌形象跳转
.profile-opts {
  display: flex;
  align-items: center;
  img {
    width: 24px;
    margin-right: 5px;
  }
}
</style>

<style lang="scss" scoped>
.creative-form {
  margin-bottom: 60px;

  //创意文案
  .description-list {
    display: flex;
    align-content: center;
    margin-bottom: 6px;

    .el-icon-remove {
      cursor: pointer;
      margin-left: 10px;
    }
  }
}
</style>
